function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { hrefToUrl, Inertia, mergeDataIntoQueryString, shouldIntercept } from '@inertiajs/inertia';
import { createEventDispatcher } from 'svelte';
export default (function (node) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _mergeDataIntoQuerySt = mergeDataIntoQueryString(options.method || 'get', hrefToUrl(node.href || options.href), options.data || {}),
      _mergeDataIntoQuerySt2 = _slicedToArray(_mergeDataIntoQuerySt, 2),
      url = _mergeDataIntoQuerySt2[0],
      data = _mergeDataIntoQuerySt2[1];

  node.href = url.href;
  options.data = data;
  var dispatch = createEventDispatcher();

  function visit(event) {
    dispatch('click', event);
    var href = node.href || options.href;

    if (!href) {
      throw new Error('Option "href" is required');
    }

    if (shouldIntercept(event)) {
      event.preventDefault();
      Inertia.visit(href, options);
    }
  }

  node.addEventListener('click', visit);
  return {
    update: function update(newOptions) {
      var _mergeDataIntoQuerySt3 = mergeDataIntoQueryString(newOptions.method || 'get', hrefToUrl(node.href || newOptions.href), newOptions.data || {}),
          _mergeDataIntoQuerySt4 = _slicedToArray(_mergeDataIntoQuerySt3, 2),
          url = _mergeDataIntoQuerySt4[0],
          data = _mergeDataIntoQuerySt4[1];

      node.href = url.href;
      newOptions.data = data;
      options = newOptions;
    },
    destroy: function destroy() {
      node.removeEventListener('click', visit);
    }
  };
});